// export const lightGradient = (color)=>{
// 	return `linear-gradient(to right, #fff, ${color})`
// };
import hexrgb from 'hex-rgb';

export const lightGradient = (color) => {
	let colorLight = hexrgb(color, {format: 'array'});
	let colorLightString = `rgba(${colorLight[0]},${colorLight[1]},${colorLight[2]},0.5)`;
	return `linear-gradient(to bottom right, ${color}, ${colorLightString})`;
};
